import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { BUTTON_SX } from '~/theme';

type Props = {
  label?: string;
  helperText?: string;
  disabled?: boolean;
  disabledReason?: string;
  onRun: () => Promise<void>;
};

export const CfiRunButton = ({
  label = 'Run ContractIQ',
  helperText,
  disabled = false,
  disabledReason,
  onRun,
}: Props) => {
  const [isBusy, setIsBusy] = useState(false);

  const handleClick = async () => {
    setIsBusy(true);
    try {
      await onRun();
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Stack alignItems="center" spacing={1.5}>
        <Button
          variant="contained"
          size="large"
          startIcon={<AutoAwesomeIcon />}
          disabled={disabled || isBusy}
          onClick={handleClick}
          sx={BUTTON_SX}
        >
          {label}
        </Button>
        {disabled && disabledReason ? (
          <Typography variant="caption" color="error.main">
            {disabledReason}
          </Typography>
        ) : null}
        {!disabled && helperText ? (
          <Typography variant="caption" color="text.secondary">
            {helperText}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
};
